// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"basestyles_maxWidth__12K4e"};